/* tslint:disable */
/* eslint-disable */
/**
 * Course Tree API
 * API specification for course tree structure
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface DidacticRule
 */
export interface DidacticRule {
  /**
   * Sub-type of didactic element
   * @type {string}
   * @memberof DidacticRule
   */
  subType?: DidacticRuleSubTypeEnum;
  /**
   * Gagne's event of instruction
   * @type {string}
   * @memberof DidacticRule
   */
  gagneEvent?: string;
  /**
   * Type of content
   * @type {string}
   * @memberof DidacticRule
   */
  contentType?: DidacticRuleContentTypeEnum;
  /**
   * Position in didactic sequence
   * @type {string}
   * @memberof DidacticRule
   */
  didacticSequence?: DidacticRuleDidacticSequenceEnum;
}

/**
 * @export
 */
export const DidacticRuleSubTypeEnum = {
  Storytelling: "STORYTELLING",
  ChapterIntro: "CHAPTER_INTRO",
  Text: "TEXT",
  Example: "EXAMPLE",
  Flashcard: "FLASHCARD",
  Quiz: "QUIZ",
  Exercise: "EXERCISE",
} as const;
export type DidacticRuleSubTypeEnum =
  (typeof DidacticRuleSubTypeEnum)[keyof typeof DidacticRuleSubTypeEnum];

/**
 * @export
 */
export const DidacticRuleContentTypeEnum = {
  Text: "TEXT",
  Video: "VIDEO",
  Interactive: "INTERACTIVE",
  Quiz: "QUIZ",
} as const;
export type DidacticRuleContentTypeEnum =
  (typeof DidacticRuleContentTypeEnum)[keyof typeof DidacticRuleContentTypeEnum];

/**
 * @export
 */
export const DidacticRuleDidacticSequenceEnum = {
  Before: "BEFORE",
  During: "DURING",
  After: "AFTER",
} as const;
export type DidacticRuleDidacticSequenceEnum =
  (typeof DidacticRuleDidacticSequenceEnum)[keyof typeof DidacticRuleDidacticSequenceEnum];

/**
 * Check if a given object implements the DidacticRule interface.
 */
export function instanceOfDidacticRule(value: object): value is DidacticRule {
  return true;
}

export function DidacticRuleFromJSON(json: any): DidacticRule {
  return DidacticRuleFromJSONTyped(json, false);
}

export function DidacticRuleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DidacticRule {
  if (json == null) {
    return json;
  }
  return {
    subType: json["sub_type"] == null ? undefined : json["sub_type"],
    gagneEvent: json["gagne_event"] == null ? undefined : json["gagne_event"],
    contentType:
      json["content_type"] == null ? undefined : json["content_type"],
    didacticSequence:
      json["didactic_sequence"] == null ? undefined : json["didactic_sequence"],
  };
}

export function DidacticRuleToJSON(json: any): DidacticRule {
  return DidacticRuleToJSONTyped(json, false);
}

export function DidacticRuleToJSONTyped(
  value?: DidacticRule | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    sub_type: value["subType"],
    gagne_event: value["gagneEvent"],
    content_type: value["contentType"],
    didactic_sequence: value["didacticSequence"],
  };
}
